"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const core_1 = require("@material-ui/core");
const react_i18next_1 = require("react-i18next");
const ListCard_1 = require("../card/ListCard");
const config_1 = require("../config/config");
const GameCard = ({ game, onPress, mediaClass, superBonusEntryCount }) => {
    const theme = (0, core_1.useTheme)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const cornerIcon = {
        text: game.retailPrice.toCurrencyFormat(),
        contentColor: game.isActive ? config_1.config.themeColors.cornerColors.gameContrast.hex() : theme.palette.text.secondary,
        trianglePosition: { top: 0, left: 0 },
        triangleType: 'topLeft',
        triangleBackgroundColor: game.isActive ? config_1.config.themeColors.cornerColors.game.hex() : theme.palette.grey['400'],
        triangleSize: 88
    };
    const superBonusBadge = !!superBonusEntryCount && superBonusEntryCount > 0 ? { text: superBonusEntryCount } : undefined;
    return ((0, jsx_runtime_1.jsx)(ListCard_1.default, { image: game.ticketFullImage, imageTitle: game.name, text: game.name, title: t('games.topPrizeType.' + game.topPrizeType) + game.getTopPrize(), titleColor: 'textSecondary', cornerIcon: cornerIcon, disableCornerIcon: config_1.config.internalConfig.DISABLE_GAME_CORNER_ICON, onClick: onPress, superBonusBadge: superBonusBadge, mediaClass: mediaClass, collectThemAllBadge: game.currentEntries }));
};
exports.default = GameCard;
//# sourceMappingURL=GameCard.js.map